import { render } from "./test_F.vue?vue&type=template&id=3c6e6de7"
import script from "./test_F.vue?vue&type=script&lang=js"
export * from "./test_F.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sisco\\Documents\\Compras\\SC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__